import React, { useEffect, useState } from 'react';
import Tooltip from "rc-tooltip";
import fetchComprehensionReport from '../../Reports/services/comprehension/fetchComprehensionReport';
import "rc-tooltip/assets/bootstrap_white.css";
import SRS from '../../../services/StudentRecordService';
import toast, { Toaster } from 'react-hot-toast';

import CRPHeader from './CRPHeader.js';
import CRPStoryBlock from './CRPStoryBlock';
import CRPStandardBlock from './CRPStandardBlock';
import CRPScoreBlock from './CRPScoreBlock';
import CRPDialogBlock from './CRPDialogBlock';
import Loading from '../../Global/Loading';
import CRPWhyBlock from './CRPWhyBlock';
import { withRouter } from 'react-router-dom';

export default withRouter(function ComprehensionReportCard({ history, match, location }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const queryParams = new URLSearchParams(location.search);
  const activityId = queryParams.get('activityId');
  const phraseIndex = parseInt(queryParams.get('phraseIndex'));

  // Passed state
  const { student } = location.state || {};

  useEffect(() => {
    fetchComprehensionReport(activityId, phraseIndex, student).then(data => {
      if (!activityId || !phraseIndex) {
        return;
      }
      setData(data);
      setLoading(false);
    });
  }, [activityId, phraseIndex]);

  function showToast(message) {

    toast.custom(
      <div style={{
          backgroundColor: 'red',
          padding: '10px',
          fontSize: '16px',
          border: '2px solid black',
          borderRadius: '10px',
          color: 'white',
        }}>
        <div className='toastTitle' style={{ fontWeight: 'bold' }}>
          Error
        </div>
        <div className='toastBody'>{message}</div>
      </div>,
      {
        duration: 100000,
      }
    );
  }

  function renderBackButton() {
    return (<a href='#' className='backButton' onClick={() => history.push('/teacher/gradebook/scoring/' + activityId)}>{"< Back"}</a>)
  }

  async function onAdjustDialogFeedback(index, newFeedback) {
    const dialog = data.dialog[index];

    try {
      const newData = { ...data };
      const response = await SRS.setComprehensionDialogFeedback(
          activityId,
          data.story.chapters[0].items[dialog.phraseIndex].interactions[0].ids[0],
          dialog.stage,
          newFeedback,
      );
      newData.dialog[index].feedback = response.feedback;
      setData(newData);
    } catch (e) {
      console.log("Error adjusting feedback: ", e);
      showToast("There was a problem saving your feedback.")
    } 
  }

  async function onAdjustScore(newScore) {
    try {
      const newData = { ...data };
      const response = await SRS.setComprehensionDialogScore(
        activityId,
        phraseIndex,
        newScore,
      );
      newData.score.numerator = response.scoreOverride;
      setData(newData);
    } catch (e) {
      console.log("Error adjusting score: ", e);
      showToast("There was a problem saving the updated score.")
    }
  }
  
  return (
    <div className='comprehensionReportCard'>
      <Toaster />
      {loading && (<Loading />)}
      {!loading && data && (
      <>
        <div className='row'>
          {renderBackButton()}
        </div>
        <div className='row'>
          <CRPHeader studentFirstName={data.header.student.firstName} studentLastName={data.header.student.lastName} date={data.header.date} />
        </div>
        <div className='row'>
          <div className='storyBlockWrapper'>
            <CRPStoryBlock title={data.story.title} chapters={data.story.chapters}/>
          </div>
          <div className='standardBlockWrapper'>
            <CRPStandardBlock title={data.standard.title} description={data.standard.description} />
          </div>
        </div>
        <div className='row'>
          <div className='scoreBlockWrapper'>
            <CRPScoreBlock numerator={data.score.numerator} denominator={data.score.denominator} onAdjustScore={onAdjustScore} />
          </div>
          <div className='whyBlockWrapper'>
            <CRPWhyBlock why={data.why} />
          </div>
        </div>
        <div className='row'>
          <CRPDialogBlock dialogs={data.dialog} onAdjustFeedback={onAdjustDialogFeedback} />
        </div>
      </>)}
    </div>
  );
});